// MatchResultsPage.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import './MatchResultsPage.css';

const MatchResultsPage = () => {
  const [results, setResults] = useState(null);

  useEffect(() => {
    axios.get('https://backend.aubattle.com/api/user/stats')
      .then(res => setResults(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="container results-page">
      <h2 className="my-4">Your Match Stats</h2>
      {results ? (
        <div className="card p-4 shadow">
          <p><strong>Total Matches Played:</strong> {results.total_matches}</p>
          <p><strong>Total Wins:</strong> {results.total_wins}</p>
          <p><strong>Coins Won:</strong> {results.total_coins}</p>
          <p><strong>Winning Rate:</strong> {results.winning_rate}%</p>
        </div>
      ) : (
        <p>Loading stats...</p>
      )}
    </div>
  );
};

export default MatchResultsPage;
